/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-card-foot{align-items:center;display:block;padding:8px 24px;background-color:#fff}.app-dialog-footer{display:flex;flex-grow:1;justify-content:space-between}.app-dialog-footer .app-icon-size-small{font-size:13px;line-height:17px}.app-dialog-footer app-button:last-child{align-self:flex-end}"];
export { styles as styles };
